export const Prices =[
    {
        _id : 0,
        name : "₹0 to 499",
        Array:[0,499]
    },
    {
        _id : 1,
        name : "₹500 to 999",
        Array:[500,999]
    },
    {
        _id : 2,
        name : "₹1K to 2K",
        Array:[1000,1999]
    },
    {
        _id : 3,
        name : "₹2K to 5K",
        Array:[2000,4999]
    },
    {
        _id : 4,
        name : "₹5k to 9k",
        Array:[5000,9999]
    },
    {
        _id : 5,
        name : "₹10K to 25k",
        Array:[10000,24999]
    },
    {
        _id : 6,
        name : "₹25K to ->",
        Array:[24000,50000]
    },
]